import { useMemo } from 'react'

import { useAdobeTargetContext } from '@ntc/lib/AdobeTarget'

import { useSelectedStoreContext } from '@context/SelectedStoreContext'
import { useUserSessionContext } from '@context/UserSessionContext'
import { SanitizeSegmentedData, sanitizeSegmentedData, SEGMENTATION_USER_CUSTOMER_TYPE } from '@lib/sanity/sanity-utils'

export const useSegmentedContent = <T>(data: T): SanitizeSegmentedData<T> => {
  const selectedStoreContext = useSelectedStoreContext()
  const useSessionContext = useUserSessionContext()
  const adobeTargetContext = useAdobeTargetContext()

  return useMemo(() => {
    const isVipProUser = useSessionContext.store.userSession?.contextAttribute?.some(
      (attribute) =>
        attribute.attributeName === 'vipProNumber' &&
        attribute.attributeValue?.some((valueObj) => valueObj.value?.some((value) => value !== ''))
    )

    return sanitizeSegmentedData({
      data,
      sessionDetails: {
        adobeTargetDetails: {
          userAudiences: [...adobeTargetContext.store.userAudiences]
        },
        selectedStore: {
          corporate: selectedStoreContext.store?.storeDetails?.corporate,
          displayBanner: selectedStoreContext.store?.storeDetails?.banner.displayedBanner,
          flyerVersion: selectedStoreContext.store?.storeDetails?.flyer.flyerVersion,
          regionCode: selectedStoreContext.store?.storeDetails?.address.state,
          size: selectedStoreContext.store?.storeDetails?.storeSize,
          storeId: selectedStoreContext.store?.storeDetails?.storeIdentifier
        },
        userDetails: {
          // PRO USER: if Loggedin User + attributeName === 'vipProNumber'
          // DIY USER: if Loggedin User + is NOT PRO
          // GUEST USER: Not Loggedin User
          type: isVipProUser
            ? SEGMENTATION_USER_CUSTOMER_TYPE.pro
            : useSessionContext.store.userSession?.logonId
              ? SEGMENTATION_USER_CUSTOMER_TYPE.diy
              : SEGMENTATION_USER_CUSTOMER_TYPE.guest
        }
      }
    })
  }, [
    data,
    useSessionContext.store.userSession?.contextAttribute,
    useSessionContext.store.userSession?.logonId,
    adobeTargetContext.store.userAudiences,
    selectedStoreContext.store?.storeDetails?.corporate,
    selectedStoreContext.store?.storeDetails?.banner.displayedBanner,
    selectedStoreContext.store?.storeDetails?.flyer.flyerVersion,
    selectedStoreContext.store?.storeDetails?.address.state,
    selectedStoreContext.store?.storeDetails?.storeSize,
    selectedStoreContext.store?.storeDetails?.storeIdentifier
  ])
}
